import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { OverlayService } from "../../services/overlay.service";
import { ProductsService } from "../../services/products.service";
import { Store } from "../../store";

@Component({
    selector: "app-product-type-config",
    templateUrl: "./product-type-config.component.html",
    styleUrls: ["./product-type-config.component.scss"],
})
export class ProductTypeConfigComponent implements OnInit {
    @Input() overlayData: any;
    @Input() areActionButtonsHidden: boolean;
    @Input() mode = "stepthrough";
    @Output() completed = new EventEmitter();

    configuration = [];
    textureIdx = 0;
    subTypeIdx = 0;
    currentTexture;
    currentSubType;
    currentPricingGroup = "random";
    subTypes = [];
    leadtimes = [];

    confirmationData = {
        open: false,
        buttonText: "Confirm",
        title: "",
        detail: "",
        data: undefined,
    };

    constructor(
        private overlayService: OverlayService,
        private store: Store,
        private toastrService: ToastrService,
        private productService: ProductsService
    ) {}

    ngOnInit(): void {
        this.loadConfiguration();
    }

    loadConfiguration() {
        this.productService
            .loadBespokeConfiguration(
                this.overlayData.range.id,
                this.overlayData.productType.id,
                this.overlayData.range.supplier
            )
            .subscribe((data) => {
                this.configuration = data.data;

                this.getTexture(0, false);
                this.getSubType(0);
            });
    }

    getTexture(idx, doSave) {
        if (doSave) {
            this.configuration[this.textureIdx] = this.currentTexture;
        }
        this.textureIdx = idx;
        this.currentTexture = JSON.parse(
            JSON.stringify(this.configuration[idx])
        );
        this.setPricingMethod(this.currentTexture.pricingMethods[0]);
        this.getSubType(0);
    }
    saveTexture() {
        this.configuration[this.textureIdx] = JSON.parse(
            JSON.stringify(this.currentTexture)
        );
    }

    getSubType(idx) {
        this.subTypeIdx = idx;
        this.currentSubType = JSON.parse(
            JSON.stringify(this.currentTexture.subTypes[idx])
        );
    }
    saveSubType() {
        this.currentTexture.subTypes[this.subTypeIdx] = this.currentSubType;
        this.configuration[this.textureIdx] = this.currentTexture;
    }

    setPricingGroup(v) {
        this.currentPricingGroup = v;
    }

    toggleFinishes(type, idx) {
        if (!this.currentSubType[type][idx].selected) {
            this.currentSubType[type][idx].selected = true;
        } else {
            delete this.currentSubType[type][idx].selected;
        }
        this.saveSubType();
    }

    toggleAllowRandom() {
        !this.currentTexture.allowRandom
            ? (this.currentTexture.allowRandom = true)
            : (this.currentTexture.allowRandom = false);
        this.saveTexture();
    }
    toggleAllowBespoke() {
        !this.currentTexture.allowBespoke
            ? (this.currentTexture.allowBespoke = true)
            : (this.currentTexture.allowBespoke = false);
        this.saveTexture();
    }

    toggleSupplied() {
        !this.currentTexture.supplied
            ? (this.currentTexture.supplied = true)
            : (this.currentTexture.supplied = false);
        this.saveTexture();
    }

    close() {
        this.completed.emit();
    }

    confirmCancel() {
        this.confirmationData.title = "Are you sure you want to cancel?";
        this.confirmationData.data = {};
        this.confirmationData.detail = "";
        this.confirmationData.open = true;
    }

    confirmationComplete(e) {
        this.confirmationData.open = false;
        if (e.action) {
            this.close();
        } else {
        }
    }

    submit() {
        this.configuration[this.textureIdx] = this.currentTexture;

        this.productService
            .saveBespokeConfiguration(
                this.overlayData.range.id,
                this.overlayData.productType.id,
                this.configuration
            )
            .subscribe((data) => {
                this.toastrService.success("Configuration saved");
                this.close();
            });
    }

    addRangeRow(o) {
        const newCostItem = {
            rangeId: this.overlayData.range.id,
            type: this.overlayData.productType.id,
            textureType: this.currentTexture.id,
            sizingType: this.currentPricingGroup,
            cost: 0,
            minThickness: 0,
            maxThickness: 100,
        };
        if (o.length) {
            newCostItem.minThickness = +o[o.length - 1].maxThickness + 1;
        }
        o.push(newCostItem);

        this.updateRangeRow(o, newCostItem.textureType, newCostItem.sizingType);
    }

    removeRangeRow(o, idx) {
        const textureType = o[0].textureType;
        const sizingType = o[0].sizingType;

        o.splice(idx, 1);
        this.updateRangeRow(o, textureType, sizingType);
    }

    updateRangeRow(o, textureType, sizingType) {
        for (let i = 0; i < this.configuration.length; i++) {
            if (textureType === this.configuration[i].id) {
                this.configuration[i].costsSQM[sizingType] = o;
            }
        }
    }

    removeLeadtime(idx) {
        this.currentTexture.leadtimes.splice(idx, 1);
    }

    addLeadtime() {
        const leadtime = {
            days: 1,
            minUnit: 1,
            maxUnit: 10,
        };
        if (this.currentTexture.leadtimes.length) {
            leadtime.minUnit =
                +this.currentTexture.leadtimes[
                    this.currentTexture.leadtimes.length - 1
                ].maxUnit + 1;
            leadtime.maxUnit = leadtime.minUnit + 10;
        }
        this.currentTexture.leadtimes.push(leadtime);
    }

    // pricing method stuff
    setPricingMethod(method) {
        this.currentTexture.pricingMethod = method;
    }
    togglePricingMethodActive() {
        if (!this.currentTexture.pricingMethod.active) {
            this.currentTexture.pricingMethod.active = true;
        } else {
            this.currentTexture.pricingMethod.active = false;
        }
        this.updatePricingMethod(this.currentTexture.pricingMethod);
    }
    updatePricingMethod(pricingMethod) {
        this.currentTexture.pricingMethods.forEach((pm, idx) => {
            if (pm.id === pricingMethod.id) {
                pm = pricingMethod;
            }
        });
    }
}
